import { teal } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";
import { redCandleTheme } from "../../../../Theme/Theme";
export const nineSolsTheme = createTheme(redCandleTheme, {
  palette: {
    mode: "dark",
    primary: {
      main: "#eac57d",
      // main: "#e0a636",
      contrastText: "#161C21",
      // dark: "#8f723b",
      dark: "#a8894d",
      // #F4CF8C
      // contrastText: "#fff",
      // dark: "#21040a"
    },
    secondary: {
      main: teal[400],
      dark: teal[600],
      contrastText: "#fff",
      // main: "#c6173c",
      // dark: "#c6173cbb",
    },

    // text: {
    //   primary: "#fffeeb",
    // },
    // secondary: {
    //   main: "#cba",
    // },
    // background: {
    //   default: "#1a1b1e",
    //   // default: "#18191a",
    //   // default: "#210D1F"
    //   // default: "#101828",
    //   // default: "#551010",
    // },
  },
  // typography: {
  //   fontFamily: "Noto Sans TC, sans-serif;",
  //   h1: {
  //     fontSize: "3rem",
  //   },
  // },
  components: {
    // MuiAppBar: {
    //   defaultProps: {
    //     elevation: 1,
    //   },
    // },
    // MuiPaper: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: "#15171a", //靛藍灰
    //       // backgroundColor: "#18191a",
    //       // backgroundColor: "#121316",
    //       // backgroundColor: "#192835",
    //       // backgroundColor: "#082532",
    //       // backgroundColor: "#122238",
    //       // backgroundColor: "#101828",
    //     },
    //   },
    // },
    // MuiButtonBase: {
    //   defaultProps: {
    //     disableRipple: true,
    //     // disableElevation: true,
    //   },
    // },
    // MuiButton: {
    //   styleOverrides: {
    //     contained: {
    //       "&:hover": {
    //         color: "#000",
    //       },
    //     },
    //   },
    // },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginTop: 6,
          marginBottom: 6,
        },
      },
    },
  },
});
